import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import Timeline from "@/pages/home/components/Timeline";
import SeriesSection from "@/pages/home/components/SeriesSection";
import ReversalSection from "@/pages/home/components/ReversalSection";
import OfficialSection from "@/pages/home/components/OfficialSection";
import RankSection from "@/pages/home/components/RankSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactSection from "@/pages/home/components/ContactSection";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";
import SeoJsonLd from "@/pages/home/components/SeoJsonLd";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SeoJsonLd />
      <Header />

      <main className="flex-1">
        <Hero />

        <nav aria-label="面包屑" className="w-full max-w-7xl mx-auto px-4 md:px-8 pt-6">
          <ol className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-foreground-500">
            <li>
              <a href="#home" className="hover:text-primary-600 transition-colors cursor-pointer">
                首页
              </a>
            </li>
            <li aria-hidden="true">
              <i className="ri-arrow-right-s-line" />
            </li>
            <li className="text-foreground-800" aria-current="page">
              网爆吃瓜连续剧追踪
            </li>
          </ol>
        </nav>

        <Timeline />
        <SeriesSection />
        <ReversalSection />
        <OfficialSection />
        <RankSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}